<template>
  <div class="unit-toggle d-flex flex-wrap align-center ga-2">
    <!-- Weight unit selector -->
    <v-btn-toggle
      :model-value="weightUnit"
      @update:model-value="setWeightUnit"
      mandatory
      density="compact"
      divided
      :disabled="displayMode !== 'absolute'"
    >
      <v-btn value="LB" size="small">lb</v-btn>
      <v-btn value="KG" size="small">kg</v-btn>
      <v-btn value="G" size="small">g</v-btn>
    </v-btn-toggle>

    <!-- Volume unit selector -->
    <v-btn-toggle
      :model-value="volumeUnit"
      @update:model-value="setVolumeUnit"
      mandatory
      density="compact"
      divided
      :disabled="displayMode !== 'absolute'"
    >
      <v-btn value="GAL" size="small">gal</v-btn>
      <v-btn value="L" size="small">L</v-btn>
    </v-btn-toggle>

    <!-- Display mode selector -->
    <v-btn-toggle
      :model-value="displayMode"
      @update:model-value="setDisplayMode"
      mandatory
      density="compact"
      divided
    >
      <v-btn value="absolute" size="small">abs</v-btn>
      <v-btn value="lb_per_gal" size="small">lb/gal</v-btn>
      <v-btn value="g_per_l" size="small">g/L</v-btn>
    </v-btn-toggle>
  </div>
</template>

<script setup>
import { useUnitPreference } from '../../composables/useUnitPreference'

const { weightUnit, volumeUnit, displayMode, setWeightUnit, setVolumeUnit, setDisplayMode } = useUnitPreference()
</script>

<style scoped>
.unit-toggle :deep(.v-btn-toggle .v-btn--active) {
  background-color: rgb(var(--v-theme-primary)) !important;
  color: white !important;
}

.unit-toggle :deep(.v-btn-toggle .v-btn:not(.v-btn--active)) {
  background-color: transparent;
  color: rgba(var(--v-theme-on-surface), 0.7);
}
</style>
